import { v4 } from 'uuid'

function uuidv4 () {
  return v4()
}

export default uuidv4
